<aw-dialog
  (onClose)="dialogRef.close($event)"
  [content]="content"
  [footer]="footer"
  [width]="width"
  [data]="data"
  [title]="data.headline">
  <ng-template #content>
    <div class="flex flex-col gap-2">
      {{
        cmsTextProvider.configuration.deleteOperatorMappingWarning
          | templateString
            : {
                operatorId: data.operatorMappingId + '',
                operatorName: data.operatorName + '',
              }
      }}
    </div>
  </ng-template>
  <ng-template #footer>
    <aw-button
      [id]="'confirm'"
      [style]="'error'"
      [type]="'button'"
      (click)="dialogRef.close({ submit: true, data, acceptChanges: false })"
      [text]="cmsTextProvider.shared.delete"
      class="mr-3 w-full" />
    <aw-button
      class="w-full"
      [id]="'cancel'"
      [type]="'button'"
      (click)="dialogRef.close()"
      [style]="'primary-alt'"
      [text]="cmsTextProvider.shared.cancel"
  /></ng-template>
</aw-dialog>
